module.exports = __webpack_public_path__ + "static/GreetingsBanner-7dc48a35f0cb76bad2c3220d732b2c23.png";